import React from 'react';
import { Helmet } from 'react-helmet';
import CreateOrUpdateUserForm from 'components/Form/Tenant/CreateOrUpdateUserForm';
import { Container } from 'reactstrap';

const UserFormPage: React.FC = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Employee Form</title>
      </Helmet>
      <Container fluid>
        <CreateOrUpdateUserForm />
      </Container>
    </div>
  );
};

export default UserFormPage;
